// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-comp[data-v-3a77b174]{width:100%;max-height:none}.picture-comp__img[data-v-3a77b174]{display:inline-block;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.picture-comp__img.position-top[data-v-3a77b174]{-o-object-position:50% 15%;object-position:50% 15%}", ""]);
// Exports
module.exports = exports;
